<template>
  <div>
    <vuestic-widget :headerText="$t(title)" :cancelButton="true" :cancelRoute="cancelRoute">
      <vuestic-alert type="danger" v-if="localAlert || externalAlert" :withCloseBtn="true">
        <span class="badge badge-pill badge-danger">Error!</span>
        {{ externalAlert ? externalAlertMessage : localAlertMessage }}
      </vuestic-alert>
      <table class="table first-td-padding object-table">
        <tbody>
          <tr>
            <th width="25%"></th>
            <th width="75%"></th>
          </tr>
          <tr
            v-if="object !== undefined"
            v-for="field in tableFields">
            <td class="key">{{ field.title }}</td>
            <td v-if="field.noneditable">
              {{object[field.name]}}
            </td>
            <td v-else-if="field.type === 'date'">
              <vuestic-date-picker
                v-model="object[field.name]"
                id="date-picker-time"
                :config="{enableTime: true, dateFormat: 'm/d/Y h:i K'}"
              />
            </td>
            <td v-else-if="field.type === 'list'">
              <vuestic-simple-select
                v-model="object[field.name]"
                v-bind:options="field['options']">
              </vuestic-simple-select>
            </td>
            <td v-else-if="field.type === 'switch'">
              <toggle-button
                @change="change(field['name'])"
                :value="object[field.name]"
                :sync="true"
                color="#009AB1"
                :labels="{checked: 'True', unchecked: 'False'}"
                :width="72"
                :height="30"
              />
            </td>
            <td style="padding-left: 2em;" v-else-if="field.type === 'file'">
              <input type="file" @change="handleFileUpload" />
            </td>
            <td class="form-group form-group2" v-else-if="field.type === 'read-only'">
              <div class="col-md-6 offset-3 form-group with-icon-right form-group2">
                <div class="input-group">
                  <input
                    :name="field['name']"
                    v-model="object[field.name]"
                    required
                    readonly/>
                </div>
              </div>
            </td>
            <td class="form-group form-group2" v-else>
              <div class="col-md-6 offset-3 form-group with-icon-right form-group2"
                   :class="{'has-error': errors.has(field.name), 'valid': isFormFieldValid(field.name)}">
                <div class="input-group">
                  <input
                    :name="field['name']"
                    v-model="object[field.name]"
                    v-validate="field['validator']"
                    required/>
                    <i
                      class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <i class="bar"></i>
                    <small v-show="errors.has(field.name)" class="help text-danger">
                      {{ field.title }} is required!
                    </small>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="padding-bottom: 20px; margin-top: 30px;" class="row actions" v-if="$mq === 'laptop' || $mq === 'desktop'">
        <div class="col-md-4 offset-md-4 text-center">
          <button class="btn btn-success btn-sm" @click="updateObject()">
            SUBMIT
          </button>
        </div>
      </div>
      <div style="padding-bottom: 20px;" class="row actions" v-else>
        <div class="col-md-12 offset-md-12 text-center" style="margin-top: 1rem;">
          <button class="btn btn-success btn-sm" @click="updateObject()">
            SUBMIT
          </button>
        </div>
      </div>
    </vuestic-widget>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'
  import store from '../../../store'
  export default {
    name: 'add-object',
    mounted: function () {
    },
    props: {
      addDefinition: {
        type: Object,
        default: () => {}
      },
      client: {
        type: Object
      },
      refresh: {
        type: Function
      },
      updateObjectAction: {
        type: Function
      },
      externalObject: {
        type: Object
      },
      externalAlert: {
        type: Boolean
      },
      externalAlertMessage: {
        type: String
      },
      externalSuccess: {
        type: Boolean
      },
      policy: {
        type: Function
      }
    },
    computed: {
      updateObject () {
        return this.updateObjectAction || this.updateObjectLocal
      }
    },
    data: function () {
      return {
        object: {},
        tableFields: this.addDefinition.tableFields,
        urls: this.addDefinition.urls,
        title: this.addDefinition.title,
        localAlert: false,
        localAlertMessage: '',
        file: '',
        fileUpload: '',
        cancelRoute: this.$route.query.origin ? '/' + this.$route.query.origin : (this.addDefinition.redirect ? '/' + this.addDefinition.redirect : '/')
      }
    },
    methods: {
      updateObjectLocal: async function () {
        try {
          store.commit('setLoading', true)
          var self = this
          self.localAlert = false
          self.localSuccess = false
          const valid = await self.$validator.validateAll()
          if (valid) {
            var temp = {}
            self.tableFields.forEach(function (field) {
              if (self.object[field.name] !== null && self.object[field.name] !== '') {
                _.set(temp, field.key, self.object[field.name])
              }
            })
            // Configure API Call
            const path = `${this.urls.addObject.url}`
            const id = self.id ? self.id : null
            const url = self.client.methods.api_url(path, id)
            let options = self.client.methods.api_options()
            let formData = null
            // Configure Uploads
            if (self.fileUpload) {
              options = self.client.methods.api_options(true) // true for file_uploads
              formData = new FormData()
              formData.append('file', self.fileUpload)
              self.tableFields.forEach((field) => {
                if (field.type !== 'file') {
                  formData.append(field.name, self.object[field.name])
                }
              })
              self.object = formData
            }
            self.object = _.omitBy(self.object, _.isNil)
            const response = await axios[this.urls.addObject.method](url,
              formData || self.object,
              options)
            self.object = response.data[self.addDefinition.name]
            temp = {}
            self.tableFields.forEach((field) => {
              temp[field.name] = _.get(self.object, field.key)
            })
            temp = _.omitBy(temp, _.isNil)
            self.object = temp
            self.localAlert = false
            if (self.refresh) {
              self.refresh()
            } else {
              if (self.addDefinition.redirect) {
                self.$router.push({ path: self.$route.query.origin ? '/' + self.$route.query.origin : '/' + self.addDefinition.redirect })
              } else {
                self.$router.go(-1)
              }
            }
          } else {
            self.localAlert = true
            self.localAlertMessage = 'Please fix error!'
          }
          store.commit('setLoading', false)
        } catch (error) {
          console.log(error)
          self.localAlert = true
          self.localAlertMessage = error.response.data.message
          store.commit('setLoading', false)
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        }
      },
      cancelObject () {
        this.$router.go(-1)
      },
      isFormFieldsValid (fields) {
        let isValid = true
        fields.forEach((field) => {
          if (this.formFields[field]) {
            this.validateFormField(field)
            let isValidTemp = (!this.formFields[field].required || this.formFields[field].validated) && this.formFields[field].valid
            if (!isValidTemp) {
              isValid = false
            }
          }
        })
        return isValid
      },
      isFormFieldValid (field) {
        let isValid = false
        if (this.formFields[field]) {
          isValid = this.formFields[field].validated && this.formFields[field].valid
        }
        return isValid
      },
      validateFormField (fieldName) {
        this.$validator.validate(fieldName, this[fieldName])
      },
      change (field) {
        this.object[field] = !this.object[field]
      },
      handleFileUpload () {
        var self = this
        self.fileUpload = event.target.files[0]
        self.file = event.target.files[0].name
      }
    }
  }
</script>
<style>
  td.key {
  text-transform: uppercase;
  font-weight: 500;
  }

  .object-table th, .object-table td {
  min-width: 120px;
  padding: 10px 20px;
  }

  .form-group2 {
    margin: 0;
    margin-bottom: 0px !important;
  }

  .table-responsive {
    overflow: visible;
  }

  .form-group input,
  .form-group textarea {
    color: #AAA;
  }
  .row.actions {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/objects/Add.vue